import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './SubscriptionCard.css';

const cx = classnames.bind(styles);

const DEFAULT_BILLING_PERIOD_VALUE = 4;

function getSubtitle(subscriptionData) {
    const weeks = subscriptionData.billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE;

    if (subscriptionData.trial) {
        return `${subscriptionData.trial.price} now, then auto-renews at ${subscriptionData.price} every ${weeks} weeks`;
    }

    return `${subscriptionData.price} auto-renews every ${weeks} weeks`;
}

function SubscriptionCard({ subscriptionData, selectedSubcriptionData, selectSubscription }) {
    const isActive = subscriptionData.plan === selectedSubcriptionData.plan;

    return (
        <label className={cx('root', { popular: subscriptionData.isPopular, active: isActive })}>
            <input
                type='radio'
                name='subscription-plan'
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Most popular
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.left}>
                    <span className={styles.radio}>
                        <span className={styles.radioDot} />
                    </span>
                    <div className={styles.planInfo}>
                        <p className={styles.name}>{subscriptionData.name}</p>
                        <p className={styles.subtitle}>{getSubtitle(subscriptionData)}</p>
                    </div>
                </div>
                <div className={styles.right}>
                    <span className={styles.price}>
                        {subscriptionData.trial?.price ?? subscriptionData.price}
                    </span>
                </div>
            </div>
        </label>
    );
}

SubscriptionCard.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubcriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired
};

export {
    SubscriptionCard
};
